import React from 'react';
import './AboutUs.css';
import Typewriter from './Typewriter';
import NeuralNetworkBackground from './NeuralNetworkBackground'; // Import background
import LinkedInIcon from './LinkedInIcon'; // Import LinkedIn icon

const AboutUs = React.forwardRef(({ inView }, ref) => {
  return (
    <section id="who-we-are" ref={ref} className="about-us-section">
      <div className="content-wrapper" style={{ position: 'relative', zIndex: 1 }}> {/* Wrap content */}
        <div className="about-us-content">
          <h2 className="about-us-title"><Typewriter id="aboutus-title" speed={100} replay={inView}>WHO <span className="highlight-text">WE ARE</span></Typewriter></h2>
          <p className="about-us-text">
            An innovative company building AI-powered applications to solve real-world problems for consumers and businesses. Our core mission is to leverage cutting-edge AI to create intelligent solutions that drive efficiency and enhance experiences, particularly consumer apps & games.
          </p>
          <p className="about-us-text">
            We also operate Dhuma Games, a specialized division revolutionizing gaming by harnessing AI to develop immersive gaming experience through AI-driven mechanics and content.
          </p>
          <p className="about-us-text">
            Led by a Founder & CEO <a href="https://www.linkedin.com/in/shankara-k-s-b4a15173/" target="_blank" rel="noopener noreferrer"><LinkedInIcon /></a> with 14+ years of experience building & managing games, 18+ years of experience working in startups.
          </p>
        </div>
      </div>
    </section>
  );
});

export default AboutUs;